import { ASSETS, NAV, CONTACT } from "@/lib/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative z-10 bg-[color:var(--relumia-ink)] text-[color:var(--relumia-base)] pt-20"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid lg:grid-cols-[1.4fr_1fr] gap-12 pb-16 border-b border-white/10">
          <div>
            <span className="inline-block rounded-md bg-white px-4 py-3">
              <img
                src={ASSETS.logo}
                alt="JAKS Pharma"
                className="h-10 w-auto"
              />
            </span>
            <p className="mt-6 max-w-sm text-[14px] leading-relaxed text-white/60">
              {CONTACT.company}. Relumia™ is a dermatologist-formulated glutathione
              brand crafted for brighter, even-toned and youthful skin.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8">
            <div>
              <div className="overline !text-gold mb-4">Explore</div>
              <ul className="space-y-3">
                {NAV.map((n) => (
                  <li key={n.href}>
                    <a
                      href={n.href}
                      className="text-[14px] text-white/70 hover:text-white transition-colors"
                    >
                      {n.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <div className="overline !text-gold mb-4">Contact</div>
              <ul className="space-y-3 text-[14px] text-white/70">
                <li className="leading-relaxed">{CONTACT.address}</li>
                <li>{CONTACT.phone}</li>
                <li>{CONTACT.email}</li>
                <li>{CONTACT.website}</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="py-10 flex flex-col md:flex-row items-center justify-between gap-6 text-[12px] text-white/40">
          <span>© {new Date().getFullYear()} {CONTACT.company}. All rights reserved.</span>
          <span>Use as directed. Consult a physician. Not for medical diagnosis.</span>
        </div>
      </div>

      <div className="overflow-hidden select-none pointer-events-none">
        <div className="font-serif font-light text-white/[0.06] text-[26vw] leading-[0.72] text-center -mb-[3vw]">
          RELUMIA
        </div>
      </div>
    </footer>
  );
}
